import React, { JSX } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    Datagrid,
    EditButton,
    BooleanField,
    FilterButton,
    ReferenceField,
    SearchInput,
    TextInput
} from 'react-admin';

const ListFilters: JSX.Element[] = [
    <SearchInput source="name" alwaysOn />,
];


const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* No gate here on purpose: react-admin asks `authProvider.canAccess` for this button
                itself, and the map there names the verb. A check beside it would be the same
                rule written twice. */}
            <CreateButton />
            <FilterButton />
        </TopToolbar>
    );
}


export const EmailFinderList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions/> }
            filters={ ListFilters }
        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="name"  />
                <TextField source="status" />
                <BooleanField source="running" />
                <ReferenceField source="customerAccount" reference="customer_accounts"  />
                <ReferenceField source="adminUser" reference="admin_users"  />
                <EditButton />
            </Datagrid>
        </List>
    );
}
